import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import {
  getLandingPages,
  getMessage,
  getMocAuthTokenAction,
  getShortUrl
} from '../actions/actions'
import { inputState } from '../state/input'
import { pageState } from '../state/page'

export const initCallback = ({ set }) => async () => {
  set(pageState, prev => ({ ...prev, loading: true }))
  try {
    const { items } = await getLandingPages({ searchTerm: '' })

    set(inputState, prev => ({
      ...prev,
      lp: items.length > 0 ? items[0].value : undefined
    }))
    set(pageState, prev => ({ ...prev, loading: true }))
  } catch (error) {
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))

    logAppError({
      appError: error,
      Component: 'UrlSelection',
      Method: 'initCallback'
    })
  }
  set(pageState, prev => ({ ...prev, loading: false, loaded: true }))
}

export const cleanupCallback = ({ reset }) => async () => {
  reset(pageState)
  reset(inputState)
}

export const confirmShortUrlCallback = ({ set, snapshot }) => async () => {
  set(pageState, prev => ({ ...prev, loading: true }))
  try {
    const { url, lp, radioValue, trackDetails } = await snapshot.getPromise(
      inputState
    )

    const [message, respMocAuth] = await Promise.all([
      getMessage(radioValue, url, lp),
      getMocAuthTokenAction()
    ])

    const resp = await getShortUrl(
      message,
      trackDetails,
      respMocAuth.access_token
    )

    let shortUrl = ''
    if (resp.State === 'done') {
      shortUrl = `${process.env.BASEDOMAIN_URL}/${resp.Data.ShortUrl}`
      if (trackDetails) {
        shortUrl += '?[_idoptintrack]'
      }
    } else {
      throw new Error()
    }

    return shortUrl
  } catch (error) {
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))

    logAppError({
      appError: error,
      Component: 'UrlSelection',
      Method: 'confirmShortUrlCallback'
    })
  }
  set(pageState, prev => ({ ...prev, loading: false, loaded: true }))
}
